import React from 'react';

interface TribeSectionProps {
  title: string;
  description: string;
}

export function TribeSection({ title, description }: TribeSectionProps) {
  return (
    <section className="py-10 md:pt-14 text-center">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl mb-6 text-blue-800 font-bold">
          {title}
        </h2>
        <p className="text-blue-800 max-w-xl mx-auto text-base" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'normal' }}>
          {description}
        </p>
      </div>
    </section>
  );
} 